import * as React from "react";
import { format } from "date-fns";
import { IPageProps } from "../interfaces/page-props";
import { RouteComponentProps } from "react-router-dom";
import MuiTableWrapper from "../components/MuiComponents/MuiTableWrapper";
import PageHead from "../components/PageHead";
import { Button, Grid, MenuItem, Select } from "@material-ui/core";
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Form,Field } from "react-final-form";
import { FormApi, SubmissionErrors } from "final-form";
import DateFnsUtils from "@date-io/date-fns";
import { IFileUpload } from "../interfaces/interfaces";
import FormGroupAdapter from "../components/FormGroupAdaptor";
import MuiTextInput from "../components/MuiComponents/MuiTextInput";
import Loading from "../components/loading";
import MySettings, { IFaxNumber, IFaxNumbers } from "../static/settings";
import App from "../App";
import MuiSelect from "../components/MuiComponents/MuiSelect";
import VoipServicesPicker from "../components/VoipServicesPicker";
interface RouteParams {}

export interface IFaxToSend {
  from:string
  destination:string
  document:{base64:string,filename:string}[]
}

const SendFaxPage: React.FC<RouteComponentProps<RouteParams> & IPageProps> = () => {
  const [sending,setSending] = React.useState(false)
  const [faxState,setFaxState] = React.useState<IFaxNumbers|undefined>(undefined)

  const getFaxNumbers = async () => {
    setFaxState(undefined)
      try{
        const settings=new MySettings()
        const faxNumbers=await settings.faxNumbers('')
        if(faxNumbers.success){
          if(faxNumbers.fromNumbers.length<1){
            throw 'Please contact your reseller to set your fax from numbers.'
          }
          setFaxState(faxNumbers)
        }else{
          if(faxNumbers.message){
            throw faxNumbers.message
          }else{
            throw 'There was a problem fetching the fax numbers.'
          }
        }
        
      }catch(err){
        let message = 'Failed to load your fax numbers.'
        if(typeof err==='string'){
          message=err
        }
        App.newNotificationError(message)
      }
    }

  React.useEffect(()=>{
    getFaxNumbers()
  },[])
  
  const onSubmit = async (formdata:IFaxToSend) => {
    const settings = new MySettings()
    setSending(true)
    try{
      const result = await settings.faxSend(formdata)
      if(result){
        if(result.success){
          App.newNotificationSuccess(result.message)
          getFaxNumbers()
        }else{
          throw result.message
        }
      }else{
        throw 'There was a problem sending the fax.'
      }
    }catch(err){
      let message = 'There was a problem sending the fax. Please check your connection and try again.'
      if(typeof err==='string'){
        message = err
      }
      App.newNotificationError(message)
    }
    setSending(false)
  }

  if(faxState===undefined){
    return <Loading />
  }

  let initialFrom=undefined
  const fromOptions:any[] = []
  for(const fromNumber of faxState.fromNumbers){
    const option = {value:fromNumber.number,label:fromNumber.name+' - '+fromNumber.number}
    fromOptions.push(option)
    if(initialFrom===undefined){
      initialFrom=fromNumber.number
    }
  }

  const destinationOptions:any[] = [<MenuItem value=""></MenuItem>]
  for(const destinationNumber of faxState.destinationNumbers){
    const option = <MenuItem value={destinationNumber.number}>{destinationNumber.name} - {destinationNumber.number}</MenuItem>
    destinationOptions.push(option)
  }

  const col: any[] = [
    {
      name: "datetime",
      label: "Date",
      options:{
        customBodyRenderLite: (dataIndex: number) => {
          const element = faxState.sentfaxes[dataIndex];
          let datetime = element.datetime.replace('T',' ')
          return datetime
        }
      }
    },{
      name: 'emailAddress',
      label: 'Email'
    },{
      name:'from',
      label:'From'
    },{
      name:'to',
      label:'To'
    },{
      name:'status',
      label:'Status'
    }
  ];

  return (<div className="content">
        <PageHead
          resellerID=""
          title="Send A Fax"
          parents={[]}
          subpages={[]}
        >
        </PageHead>
        <Form mutators={{
          setDestination:(args,state,utils)=>{
            utils.changeValue(state,'destination',()=>args[0])
          },
          setDestinationName:(args,state,utils)=>{
            utils.changeValue(state,'destinationName',()=>args[0])
          },setServiceId:(args,state,utils)=>{
            utils.changeValue(state,'customersSitesServicesId',()=>args[0])
          }}}
                        onSubmit={onSubmit}
                        initialValues={{from:initialFrom}}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                          const onDestinationSelectChange = (e:any) => {
                            form.mutators.setDestination(e.target.value)
                            for(const destinationNumber of faxState.destinationNumbers){
                              if(e.target.value===destinationNumber.number){
                                form.mutators.setDestinationName(destinationNumber.name)
                              }
                            }
                          }

                          const onServiceChosen = (serviceId:string) => {
                            form.mutators.setServiceId(serviceId)
                          }

                            return <form onSubmit={handleSubmit}>
                                <div className="popupContent test-new-customer-start WHITEN">
                                    <br />
                                    <fieldset>
                                        <div className="form-group">
                                            <p>Please upload a PDF to fax:</p>
                                            <Field
                                                accept="application/pdf"
                                                name="newFile"
                                                buttonLabel="Upload PDF"
                                                component={FormGroupAdapter}
                                                inputOnChange={(sdata: any) => {
                                                    //  console.log("on change", sdata);

                                                    const reader = new FileReader();
                                                    const file = sdata.target.files[0];

                                                    reader.readAsDataURL(file);
                                                    reader.addEventListener("load", function () {
                                                        // console.log("onload", reader.result);
                                                        if (typeof reader.result === "string") {
                                                            const numberPortTemplate: IFileUpload = {
                                                                base64: reader.result,
                                                                filename: file.name,
                                                            };
                                                            form.change("document", [
                                                                numberPortTemplate,
                                                            ]);
                                                        }
                                                    });
                                                }}
                                                placeholder="Upload document"
                                            />
                                        </div>
                                        <div className="form-group">
                                          Please choose the site to send the fax from:
                                          <VoipServicesPicker name="customersSitesServicesId" onServiceChosen={onServiceChosen} />
                                        </div>
                                        <div className="form-group">
                                          Please enter the phone number you want to send the fax from:&nbsp;&nbsp;
                                          <MuiSelect name="from" required={true} options={fromOptions}>
                                          </MuiSelect>
                                        </div>
                                        <div className="form-group">
                                          Please enter the phone number you want to send the fax to:
                                          <MuiTextInput
                                            outlinedLabel="Phone number e.g 01142994032"
                                            name="destination"
                                            required={true}
                                          />
                                          <br /><br />
                                          <MuiTextInput
                                            outlinedLabel="Optional name for this number."
                                            name="destinationName"
                                            required={false}
                                          />
                                          Or choose from a previous number you sent to:&nbsp;&nbsp;
                                          <Select onChange={onDestinationSelectChange}>{destinationOptions}</Select>
                                        </div>
                                    </fieldset>
                                                {sending ? (<Loading />) : (<button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={submitting || pristine}>Send Fax</button>)}
                                    
                                <br />
                                </div>
                            </form>
                        }} />
        <MuiTableWrapper
            title=""
            data={faxState.sentfaxes}
            columns={col}
            options={{
              selectToolbarPlacement:'none',
              selectableRows: "none",
              responsive: "standard",
              elevation: 0,
              print: false,
              download: false,
              search: true,
              filter: false,
              viewColumns: false,
              sortOrder: {
                name: "datetime",
                direction: "desc",
              },
            }}
          />
      </div>)
}
export default SendFaxPage;